import React from 'react';
import Box, { BoxProps } from '@mui/material/Box';

interface MainWrapperProps {
  children: React.ReactNode;
  header?: React.ReactNode;
  onlyMain?: boolean;
  mainProps?: BoxProps;
}

function MainWrapper({ children, header, mainProps, onlyMain = false }: MainWrapperProps) {
  return (
    <>
      {!onlyMain && header ? header : null}
      <Box component="main" height="100%" {...mainProps}>
        {children}
      </Box>
    </>
  );
}

export default MainWrapper;
